<template>
    <div>
        <button
            :type="type"
            class="ppv2-flex ppv2-items-center ppv2-border-none ppv2-bg-transparent ppv2-opacity-50 hover:ppv2-opacity-80 ppv2-transition-opacity ppv2-duration-200 ppv2-ease-in-out ppv2-cursor-pointer ppv2-p-0 back-btn ppv2-text-black dark:ppv2-text-white"
            @click="navigate"
            :style="{ fontSize: normalizeFontSize(16) }"
        >
            <span>‹ {{ $t('common.return') }}</span>
        </button>
    </div>
</template>
<script>
import normalizeSize from '../../utils/normalizeSize'
import normalizeFontSize from '../../utils/normalizeFontSize'

export default {
    name: 'BackButton',
    methods: {
        normalizeFontSize,
        navigate(event) {
            if (this.baseUrl) {
                if (this.$router) {
                    this.$router.push(this.baseUrl)
                } else {
                    window.location.href = this.baseUrl
                }
            } else {
                this.$emit('click', event)
            }
        },
    },
    props: {
        baseUrl: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'button',
        },
    },
}
</script>
